import { Link } from 'react-router-dom';
import { collections } from '@/mocks/collections';
import CollectionCard from '@/components/feature/CollectionCard';

export default function FeaturedCollections() {
  const sorted = [...collections].sort((a, b) => b.views - a.views);
  const featured = sorted[0];
  const rest = sorted.slice(1, 4);

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 md:mb-10">
          <span className="text-xs md:text-sm label-font text-primary-600 tracking-[0.2em]">
            FEATURED
          </span>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            精选合集 · 完结度最高
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl">
            这几个专题的节点最完整、更新最勤，适合第一次来的朋友从它们开始看。
          </p>
        </div>

        <div className="mb-5">
          <CollectionCard item={featured} featured />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rest.map((item, index) => (
            <CollectionCard key={item.id} item={item} index={index} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/collections"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-foreground-900 text-background-50 text-sm label-font hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            进入合集库，浏览全部 {collections.length} 个专题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}